const map = {
	"./cn1.png": 2367,
	"./cn2.png": 9908,
	"./cn3.png": 1037,
	"./cn4.png": 1890,
	"./cn5.png": 5547,
	"./cn6.png": 144,
	"./cn7.png": 2249
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4969;